import useSWR from "swr";

type MenuImages = {
  id: string;
  restaurant: string;
  menu_type: string;
  img: string;
  menu_num: string;
}[]
export const useFetchKoreanFoodMenuByRestaurantId = (restaurantId: string) => {
  const fetcherKey = restaurantId ? `menu/restaurants/${restaurantId}/food/korean/` : null;
  const { data: foodMenuImages, error, isLoading } = useSWR<MenuImages>(fetcherKey)
  return { foodMenuImages, isLoading, error };
};